export enum Route {
  HOME = "/",
}
